// The signed-in user and its customer, as the gateway reads them from deepickCore.

const urn = id => (id ? `urn:uuid:${id}` : undefined);

// The user in the shape the pages read: `user` and `customer` as urn:uuid IRIs, `roles` as the
// comma-separated list deepickCore stores. Null without a session or for an account without customer.
export async function fetchCurrentUser() {
  const response = await fetch('/v2/whoami', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
  if (response.status === 401 || response.status === 403) {
    window.dispatchEvent(new CustomEvent('auth:session-expired'));
    return null;
  }
  if (!response.ok) return null;
  const w = await response.json();
  if (!w.core_id || !w.customer_id) return null;
  return {
    user: urn(w.user),
    name: w.name,
    roles: (w.roles || []).join(','),
    email: w.email,
    active: String(w.active),
    organization: w.customer_name,
    customer: urn(w.customer_id),
    invitation_code: w.invitation_code,
    trial_ends_at: w.trial_ends_at,
    profile_picture: w.profile_picture,
    defaultIndustry: w.default_industry,
    mainType: w.main_type,
    deeplake: w.deeplake
  };
}

// The user's customer: name, trial and contract dates, and its users (every user with the last login
// for the customer's administrators, the administrators for everyone else), roles comma-separated.
export async function fetchMyCustomer() {
  const response = await fetch('/v2/my-customer', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
  if (!response.ok) return null;
  const c = await response.json();
  return {
    ...c,
    users: (c.users || [])
      .map(u => ({ name: u.name, email: u.email, roles: (u.roles || []).join(','), active: u.active, lastLogin: u.last_login }))
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
  };
}

// The user's notification answers, sent and waiting, newest first, in the rows the notification
// table reads: `content` is the answer's JSON as text.
export async function fetchMyNotifications(limit = 100) {
  const response = await fetch(`/v2/my-notifications?limit=${limit}`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
  if (!response.ok) return [];
  return (await response.json()).map(a => ({
    answer: a.id,
    requesttype: a.request_type,
    createdOn: a.created_on,
    emailsent: a.email_sent,
    content: a.data || '{}'
  }));
}
